import { Icon56LockOutline } from '@vkontakte/icons';
import { Text, Title } from '@vkontakte/vkui';
import React, { type ReactElement, memo } from 'react';

import styles from './BlockedB2BOverquota.css';

export const BlockedB2BOverquota = memo(function BlockedB2BOverquota(): ReactElement {
    return (
        <div className={styles.root}>
            <Icon56LockOutline className={styles.icon} />

            <div className={styles.text}>
                <Title level="1" className={styles.title}>
                    Хранилище организации переполнено
                </Title>
                <Text className={styles.description}>Диск временно недоступен</Text>
            </div>
        </div>
    );
});
